
export const transportCarbonFootprint =
{
  "idShort": "TransportCarbonFootprint1",
  "displayName": [
    {
      "language": "en",
      "text": "Transport Carbon Footprint"
    },
    {
      "language": "de",
      "text": "Transport-CO2-Fu\u00DFabdruck"
    }
  ],
  "description": [
    {
      "language": "en",
      "text": "Balance of greenhouse gas emissions generated by a transport service of a product"
    },
    {
      "language": "de",
      "text": "Bilanz der Treibhausgasemissionen, die durch eine Transportdienstleistung eines Produkts erzeugt werden"
    }
  ],
  "semanticId": {
    "type": "ExternalReference",
    "keys": [
      {
        "type": "GlobalReference",
        "value": "0173-1#01-AHE717#001"
      }
    ]
  },
  "value": [
    {
      "idShort": "TCFCalculationMethod",
      "displayName": [
        {
          "language": "en",
          "text": "TCF Calculation Method"
        },
        {
          "language": "de",
          "text": "TCF-Berechnungsmethode"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Standard, method for determining the greenhouse gas emissions for the transport of a product"
        },
        {
          "language": "de",
          "text": "Standard, Methode zur Bestimmung der Treibhausgasemissionen beim Transport eines Produkts"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABG859#001"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "",
      "valueId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABG859#001"
          }
        ]
      },
      "modelType": "Property"
    },
    {
      "idShort": "TCFCO2eq",
      "displayName": [
        {
          "language": "en",
          "text": "TCF CO2 Equivalent"
        },
        {
          "language": "de",
          "text": "TCF-CO2-\u00C4quivalent"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Sum of all greenhouse gas emissions from vehicle operation"
        },
        {
          "language": "de",
          "text": "Summe aller Treibhausgasemissionen aus dem Fahrzeugbetrieb"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABG860#001"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "",
      "modelType": "Property"
    },
    {
      "idShort": "TCFReferenceValueForCalculation",
      "displayName": [
        {
          "language": "en",
          "text": "TCF Reference Value for Calculation"
        },
        {
          "language": "de",
          "text": "TCF-Referenzwert f\u00FCr die Berechnung"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Amount of product to which the TCF carbon footprint statement relates"
        },
        {
          "language": "de",
          "text": "Produktmenge, auf die sich die TCF-CO2-Fu\u00DFabdruck-Erkl\u00E4rung bezieht"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABG861#001"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "",
      "modelType": "Property"
    },
    {
      "idShort": "TCFQuantityOfMeasureForCalculation",
      "displayName": [
        {
          "language": "en",
          "text": "TCF Quantity of Measure for Calculation"
        },
        {
          "language": "de",
          "text": "TCF-Mengenangabe f\u00FCr die Berechnung"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Quantity of the product to which the TCF information on the CO2 footprint refers"
        },
        {
          "language": "de",
          "text": "Menge des Produkts, auf die sich die TCF-Informationen zum CO2-Fu\u00DFabdruck beziehen"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABG862#001"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "21832",
      "modelType": "Property"
    },
    {
      "idShort": "TCFProcessesForGreenhouseGasEmissionInATransportService",
      "displayName": [
        {
          "language": "en",
          "text": "TCF Processes for Greenhouse Gas Emission in a Transport Service"
        },
        {
          "language": "de",
          "text": "TCF-Prozesse f\u00FCr Treibhausgasemissionen in einem Transportdienst"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Processes in a transport service to determine the sum of all direct or indirect greenhouse gas emissions from fuel supply and vehicle operation"
        },
        {
          "language": "de",
          "text": "Prozesse in einem Transportdienstleistungsunternehmen zur Ermittlung der Summe aller direkten und indirekten Treibhausgasemissionen aus der Kraftstoffversorgung und dem Fahrzeugbetrieb"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABG863#001"
          }
        ]
      },
      "valueType": "xs:string",
      "value": "",
      "valueId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#07-ABU216#001"
          }
        ]
      },
      "modelType": "Property"
    },
    {
      "idShort": "TCFGoodsTransportAddressTakeover",
      "displayName": [
        {
          "language": "en",
          "text": "PCF Goods Address Takeover"
        },
        {
          "language": "de",
          "text": "PCF-Waren\u00FCbernahmeadresse"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Indication of the place of receipt of goods"
        },
        {
          "language": "de",
          "text": "Angabe des Warenempfangsortes"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI499#001"
          }
        ]
      },
      "value": [
        {
          "idShort": "Street",
          "displayName": [
            {
              "language": "en",
              "text": "Street"
            },
            {
              "language": "de",
              "text": "Stra\u00DFe"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Street address of the place where goods were received"
            },
            {
              "language": "de",
              "text": "Stra\u00DFenangabe des Ortes der Waren\u00FCbernahme"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH956#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "HouseNumber",
          "displayName": [
            {
              "language": "en",
              "text": "House Number"
            },
            {
              "language": "de",
              "text": "Hausnummer"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Number for identification or differentiation of individual houses of a street"
            },
            {
              "language": "de",
              "text": "Nummer zur Identifizierung oder Unterscheidung einzelner H\u00E4user einer Stra\u00DFe"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH957#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "ZipCode",
          "displayName": [
            {
              "language": "en",
              "text": "Zip Code"
            },
            {
              "language": "de",
              "text": "Postleitzahl"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Postcode of the goods receipt address"
            },
            {
              "language": "de",
              "text": "Postleitzahl der Waren\u00FCbernahmeadresse"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH958#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "CityTown",
          "displayName": [
            {
              "language": "en",
              "text": "City/Town"
            },
            {
              "language": "de",
              "text": "Stadt/Gemeinde"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Indication of the place of goods receipt"
            },
            {
              "language": "de",
              "text": "Angabe des Ortes der Waren\u00FCbernahme"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH959#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "Country",
          "displayName": [
            {
              "language": "en",
              "text": "Country"
            },
            {
              "language": "de",
              "text": "Land"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Country to where the product is transmitted"
            },
            {
              "language": "de",
              "text": "Land, zu dem das Produkt \u00FCbermittelt wird"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-AAO259#005"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "Latitude",
          "displayName": [
            {
              "language": "en",
              "text": "Latitude"
            },
            {
              "language": "de",
              "text": "Breitengrad"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Latitude"
            },
            {
              "language": "de",
              "text": "Breitengrad"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH960#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "Longitude",
          "displayName": [
            {
              "language": "en",
              "text": "Longitude"
            },
            {
              "language": "de",
              "text": "L\u00E4ngengrad"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Longitude"
            },
            {
              "language": "de",
              "text": "L\u00E4ngengrad"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH961#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        }
      ],
      "modelType": "SubmodelElementCollection"
    },
    {
      "idShort": "TCFGoodsTransportAddressHandover",
      "displayName": [
        {
          "language": "en",
          "text": "PCF Goods Address Handover"
        },
        {
          "language": "de",
          "text": "PCF-Waren\u00FCbergabeadresse"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Indicates the hand-over address of the goods transport"
        },
        {
          "language": "de",
          "text": "Gibt die \u00DCbergabeadresse des G\u00FCtertransports an."
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "0173-1#02-ABI498#001"
          }
        ]
      },
      "value": [
        {
          "idShort": "Street",
          "displayName": [
            {
              "language": "en",
              "text": "Street"
            },
            {
              "language": "de",
              "text": "Stra\u00DFe"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Street indication of the place of transfer of goods"
            },
            {
              "language": "de",
              "text": "Stra\u00DFenangabe des Ortes der Waren\u00FCbergabe"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH956#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "HouseNumber",
          "displayName": [
            {
              "language": "en",
              "text": "House Number"
            },
            {
              "language": "de",
              "text": "Hausnummer"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Number for identification or differentiation of individual houses of a street"
            },
            {
              "language": "de",
              "text": "Nummer zur Identifizierung oder Unterscheidung einzelner H\u00E4user einer Stra\u00DFe"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH957#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "ZipCode",
          "displayName": [
            {
              "language": "en",
              "text": "Zip Code"
            },
            {
              "language": "de",
              "text": "Postleitzahl"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Zip code of the goods transfer address"
            },
            {
              "language": "de",
              "text": "Postleitzahl der Waren\u00FCbergabeadresse"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH958#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "CityTown",
          "displayName": [
            {
              "language": "en",
              "text": "City/Town"
            },
            {
              "language": "de",
              "text": "Stadt/Gemeinde"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Indication of the city or town of the transfer of goods"
            },
            {
              "language": "de",
              "text": "Angabe des Ortes der Waren\u00FCbergabe"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH959#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "Country",
          "displayName": [
            {
              "language": "en",
              "text": "Country"
            },
            {
              "language": "de",
              "text": "Land"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Country from where the product is transmitted"
            },
            {
              "language": "de",
              "text": "Land, von dem das Produkt \u00FCbermittelt wird"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-AAO259#005"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "Latitude",
          "displayName": [
            {
              "language": "en",
              "text": "Latitude"
            },
            {
              "language": "de",
              "text": "Breitengrad"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Latitude"
            },
            {
              "language": "de",
              "text": "Breitengrad"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH960#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        },
        {
          "idShort": "Longitude",
          "displayName": [
            {
              "language": "en",
              "text": "Longitude"
            },
            {
              "language": "de",
              "text": "L\u00E4ngengrad"
            }
          ],
          "description": [
            {
              "language": "en",
              "text": "Longitude"
            },
            {
              "language": "de",
              "text": "L\u00E4ngengrad"
            }
          ],
          "semanticId": {
            "type": "ExternalReference",
            "keys": [
              {
                "type": "GlobalReference",
                "value": "0173-1#02-ABH961#001"
              }
            ]
          },
          "valueType": "xs:string",
          "value": "",
          "modelType": "Property"
        }
      ],
      "modelType": "SubmodelElementCollection"
    },
    {
      "idShort": "PublicationDate",
      "displayName": [
        {
          "language": "en",
          "text": "Publication Date"
        },
        {
          "language": "de",
          "text": "Ver\u00F6ffentlichungsdatum"
        }
      ],
      "description": [
        {
          "language": "en",
          "text": "Time at which something was first published or made available"
        },
        {
          "language": "de",
          "text": "Zeitpunkt, zu dem etwas erstmals ver\u00F6ffentlicht oder zug\u00E4nglich gemacht wurde"
        }
      ],
      "semanticId": {
        "type": "ExternalReference",
        "keys": [
          {
            "type": "GlobalReference",
            "value": "https://admin-shell.io/idta/CarbonFootprint/PublicationDate/1/0"
          }
        ]
      },
      "valueType": "xs:date",
      "value": "",
      "modelType": "Property"
    }
  ],
  "modelType": "SubmodelElementCollection"
};